<template>
    <div class="category">
        <div class="ssk">
            <van-search
                    v-model="name"
                    :show-action="showAction"
                    placeholder="请输入搜索关键词"
                    @search="onSearch"
                    @cancel="onCancel"
                    @focus="onFocus"/>
        </div>
        <!--        <div style="border-bottom: #eeeeef solid 1px;height: 38px;">-->
        <!--            <van-tabs v-model="active" @click="onClick" class="selectTab">-->
        <!--                <van-tab :title="cat.categoryName" v-for="(cat,index) in cats" :key="index"/>-->
        <!--            </van-tabs>-->
        <!--        </div>-->
        <div class="twocats" :style="{ height: screenHeight + 'px' }">
            <div class="commodity">
                <!--// 左侧导航内容 -->
                <div class="leftNav">
                    <ul>
                        <li v-for="(item, index) in shopList" :key="index"
                            class="typeStyle"
                            ref="liref"
                            @click="onClickNav(index)">
                            <div style="width: 100%">
<!--                                <span class="catName" v-if="item.catName">{{item.catName}}</span>-->
                                <span class="leftTit"
                                      :class="{ leftTit1: index === tabIndex }">{{ item.categoryName }}</span>
                            </div>
                        </li>
                        <li class="typeStyle1"></li>
                    </ul>
                </div>
                <!--// 右侧商品内容 -->
                <div class="rightContant">
                    <ul ref="shopContant">
                        <li class="eventList" v-for="(item, index) in shopList" :key="index">
<!--                            <div class="rightTtitle">{{ item.categoryName }}</div>-->
                            <ul>
                                <li class="gather" v-for="(spu, index) in item.spus" :key="index"
                                    @click="toSpuDetails(spu.id)">
                                    <div class="spus">
                                        <img :src="spu.coverImg" class="skuitem-img"/>
                                        <div class="spi">
                                            <div class="skuitem-name">
                                                <span class="spu-name">{{spu.spuName}}</span>
                                            </div>
                                            <div class="skuitem-price">
                                                <span class="spu-jg">¥{{spu.skuPrice}}<span class="spu-yj">¥{{spu.costPrice}}</span></span>
                                            </div>
                                            <div class="skuitem-btn">
                                                <span >已售 {{spu.salesVolume}}</span>
                                                <van-icon name="shopping-cart-o" size="18px" style="margin-top: 10px" />
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <div style="height:1px"></div>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getDeptId, getDeptName} from "../../utils/auth";
    import BScroll from "better-scroll"; //引入BScroll插件
    export default {
        data() {
            return {
                name: '',
                showAction: false,
                active: '',
                tabIndex: 0,
                sd: false,
                //优选
                cats: [],
                shopList: [],
                activeId: '',
                mainActiveIndex: '',
                screenHeight: '',

                scrollY: 0, // 右侧滑动的时候距离顶部的值
                rightSide: [], // 所有右侧分类li的top组成的数组  (列表第一次显示后就不再变化)
            };
        },
        async mounted() {
            document.title = getDeptName()
            this.screenHeight = window.innerHeight - 108
            this.deptId = getDeptId()
            await this.getCats()
            this.initializeRoll(); //滑动初始化方法
            this.initializeOwn(); //初始化rightSide方法
        },
        methods: {
            onSearch() {
                this.$toast(this.value);
            },
            onFocus() {
                this.showAction = true;
            },
            onCancel() {
                this.showAction = false;
            },
            onClick(val) {
                let cat = this.cats[val]
                this.tabIndex = 0
            },

            async getCats() {
                let data = {
                    deptId: this.deptId,
                    catType: 0,
                }
                let res = await this.$get("/spm/getSpmCats", data)
                // res.list.forEach(item => {
                //     item.spus = [item.spus, ...item.spus, ...item.spus, ...item.spus, ...item.spus]
                //     item.catName = ''
                // })
                // res.list = [...res.list, ...res.list, ...res.list, ...res.list, ...res.list, ...res.list]
                this.shopList = res.list
                // let item = JSON.parse(JSON.stringify(this.shopList[0]))
                // item.catName = '管家'
                // this.shopList.unshift(item)
                // let item1 = JSON.parse(JSON.stringify(this.shopList[10]))
                // item1.catName = '管家'
                // this.shopList.splice(5, 0, item1);
            },
            //左侧点击事件
            onClickNav(index) {
                this.tabIndex = index
                this.sd = true
                //拿到目标位置的scrollY，点击左侧导航，右侧列表滑动到对应的位置
                const scrollY = this.rightSide[index];
                // 点击的分类成为当前分类，索引当前选中的导航标题
                this.scrollY = scrollY;
                // 平滑滑动右侧列表
                this.foodsScroll.scrollTo(0, -scrollY, 300);
            },
            // 初始化滚动
            initializeRoll() {
                // new一个类的实例，前提必须确保父元素和子元素的内容已经正确渲染了，不然不会生效
                this.leftScroll = new BScroll(".leftNav", {
                    click: true,
                    mouseWheel: true
                });
                // 组件实例上挂属性
                this.foodsScroll = new BScroll(".rightContant", {
                    probeType: 3, // 因为惯性滑动不会触发
                    click: true,
                    mouseWheel: true
                });

                // 给右侧列表绑定scroll监听
                this.foodsScroll.on("scroll", ({x, y}) => {
                    this.scrollY = Math.abs(y);
                    if (!this.sd) {
                        this.tabIndex = this.currentIndex()
                    }
                    this.onRightScroll()
                });
                // 给右侧列表绑定scroll结束的监听
                this.foodsScroll.on("scrollEnd", ({x, y}) => {
                    // console.log("操作结束的下标值" + x, y);
                    this.scrollY = Math.abs(y);
                    this.sd = false
                });
            },
            onRightScroll(str) {
                // 这里假设你已经有逻辑来确定 selectedCategory
                // 获取元素位置
                const lis = this.$refs.liref;
                const li = lis[this.tabIndex];
                const categoryRect = li.getBoundingClientRect();
                // console.log(categoryRect)
                // 获取左侧 BScroll 实例信息
                const currentY = this.leftScroll.y;
                const viewportHeight = this.leftScroll.wrapper.clientHeight;
                // 判断元素是否在可视区域内
                if (categoryRect.top + currentY < 0 || categoryRect.bottom + currentY > viewportHeight) {
                    // 如果不在可视区域内，滚动到该元素
                    if (typeof this.leftScroll.scrollToElement === 'function') {
                        // 使用 scrollToElement 方法（如果支持）
                        this.leftScroll.scrollToElement(li, 300);
                    } else {
                        // 手动计算滚动位置
                        const scrollToPosition = categoryRect.top - viewportHeight / 2 + currentY;
                        this.leftScroll.scrollTo(0, scrollToPosition, 300);
                    }
                }
            },

            // 初始化rightSide
            initializeOwn() {
                // 初始化rightSide
                const rightSide = [];
                let top = 0;
                rightSide.push(top);
                // 找到所有分类下的li
                const lis = this.$refs.shopContant.getElementsByClassName("eventList"); //获取dom元素lii（eventList），对其进行操作
                // slice() 方法返回一个新的数组对象
                Array.prototype.slice.call(lis).forEach(li => {
                    top += li.clientHeight; //相当于top = top + li.clientHeight
                    rightSide.push(top);
                });
                //更新数据
                this.rightSide = rightSide;
            },
            currentIndex() {
                const {
                    scrollY,
                    rightSide
                } = this; //拿到每次滑动的值以及每一个分类的下标值
                // console.log('滚动的值及每一个分类的下标值...', this)
                //findIndex() 方法返回传入一个测试条件（函数）符合条件的数组第一个元素位置
                //获取数组rightSide中每一个下标值并筛选条件返回第一个元素索引位置
                const index = rightSide.findIndex((top, index) => {
                    // scrollY>=当前top && scrollY<下一个top
                    return scrollY >= top && scrollY < rightSide[index + 1];
                });
                // 返回结果
                return index;
            },
            toSpuDetails(id) {
                this.$router.push('/spuDetails/' + this.deptId + '/' + id)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .category {
        overflow: hidden;
        width: 100vw;
        height: 100vh;
    }

    .ssk {
        height: 58px;
    }

    .cats {
        display: flex;
        flex-flow: row wrap;
        width: 95%;
        margin: auto;
    }

    ::v-deep .van-sidebar-item__text {
        position: relative;
        display: inline-block;
        word-break: break-all;
        font-size: 15px;
    }

    ::v-deep .van-tree-select__nav-item {
        padding: 8px 12px;
    }

    .van-tree-select__nav {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -ms-flex: 1;
        flex: 0.6;
        overflow-y: auto;
        background-color: #f7f8fa;
        -webkit-overflow-scrolling: touch;
        height: 100vw;
    }

    .selectTab /deep/ .van-tabs--line {
        height: 33px;
    }

    .selectTab /deep/ .van-tabs__wrap {
        height: 33px;
    }

    .selectTab /deep/ .van-tab--active {
        color: #323233;
        font-weight: 500;
        font-size: 14px;
        width: 100px;
    }


    .twocats {
        display: flex;
        flex-direction: row;
    }

    .commodity {
        /* 最大的盒子样式 */
        display: flex;
        flex-direction: row;
        position: fixed;
        top: 55px;
        bottom: 50px;
        width: 100%;
        background: #fff;
        overflow: hidden;
    }

    .leftNav {
        width: 26%;
        background: rgb(248, 248, 248);
    }

    .typeStyle {
        font-weight: bold;
        display: flex;
        color: #000000;
        margin-left: 1px;
    }

    .typeStyle1 {
        font-weight: bold;
        display: flex;
        color: #000000;
        margin-left: 1px;
        height: 30px;
    }

    .catName {
        display: block;
        text-align: center;
        height: 40px;
        line-height: 60px;
        font-size: 15px;
        color: #777777;
    }

    .leftTit {
        width: 98%;
        display: block;
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        text-align: center;
        border-left: 3px solid #FFFFFF;
        margin-left: 1px;
    }

    .leftTit1 {
        width: 98%;
        display: block;
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        text-align: center;
        border-left: 3px solid #EE0A24;
        margin-left: 1px;
        background-color: #FFFFFF;
    }

    .rightContant {
        width: 72%;
    }

    .rightTtitle {
        /* 右侧标题样式 */
        padding-left: 12px;
        height: 26px;
        line-height: 26px;
        font-size: 12px;
        font-weight: bold;
        color: rgb(147, 153, 159);
        margin: 0;
    }

    .gather {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-items: center;
        margin-bottom: 10px;
        padding-left: 5px;
    }

    .gather .skuitem-img {
        /* 右侧图片样式 */
        width: 75px;
        height: 75px;
        vertical-align: middle;
    }

    .spus {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 75px;
    }

    .spi {
        width: 62%;
        display: flex;
        flex-direction: column;
    }

    .skuitem-name {
        padding-left: 12px;
        height: 25px;
        line-height: 15px;
    }
    .spu-name {
        display: block;
        font-size: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .skuitem-price {
        flex: 1;
        padding-left: 12px;
        height: 25px;
        line-height: 18px;
    }

    .spu-jg {
        font-size: 15px;
        color: #ff4d51;
    }

    .spu-yj {
        text-decoration: line-through;
        color: #888888;
        font-size: 10px;
        margin-left: 5px;
    }

    .skuitem-btn {
        flex: 1;
        padding-left: 12px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        justify-items: center;
        align-items: center;
        height: 25px;
    }

    .skuitem-btn span{
        height: 25px;
        line-height: 35px;
        width: 50%;
        font-size: 13px
    }

</style>
